import { FluidGrid } from '@design-system/fluid-grid';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { ItemListingProps } from '../models';

export const ItemListingCounter = forwardRef<
  HTMLDivElement,
  Omit<ItemListingProps, 'type'>
>(({ pageBlock, fluidGrid, items, id, uid }, ref) => (
  <PageBlock
    {...pageBlock}
    className="item-listing-counter-block"
    id={id}
    componentUid={uid}
    ref={ref}
  >
    <FluidGrid {...fluidGrid}>{items}</FluidGrid>
  </PageBlock>
));

export default ItemListingCounter;
